<script lang="ts">
    import { navigate } from "svelte-navigator";
    import { isLoggedIn, sessionReady } from "../services/session";

    let allowRoute = false;

    $: onSessionReady($sessionReady);

    function onSessionReady(sessionReady: boolean): void {
        if (!sessionReady) {
            return;
        }
        checkIfAllowRoute();
    } 

    function checkIfAllowRoute(): void {

        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }

        allowRoute = true;
    }

</script>

{#if !$sessionReady}
Comprobando la sesión...
{:else if allowRoute}
<slot />
{/if}
